import { MIGRATION_STATUS_REDIRECTS_SET_FAILED } from '../../constants/migration-status';
import createAction from '../../services/create-action';
import { isOwner } from '../current-user/current-user-selectors';
import { getViewMode } from '../search-params/search-params-selectors';
export const CONTENT_MIGRATION_FETCH_STATUS_REQUEST = 'contentMigration/FETCH_STATUS_REQUEST';
export const CONTENT_MIGRATION_FETCH_STATUS_SUCCESS = 'contentMigration/FETCH_STATUS_SUCCESS';
export const CONTENT_MIGRATION_FETCH_STATUS_FAILURE = 'contentMigration/FETCH_STATUS_FAILURE';
export const CONTENT_MIGRATION_SET_STATUS = 'contentMigration/SET_STATUS';
export const contentMigrationFetchStatusRequest = createAction(CONTENT_MIGRATION_FETCH_STATUS_REQUEST);
export const contentMigrationFetchStatusSuccess = createAction(CONTENT_MIGRATION_FETCH_STATUS_SUCCESS);
export const contentMigrationFetchStatusFailure = createAction(CONTENT_MIGRATION_FETCH_STATUS_FAILURE);
export const contentMigrationSetStatus = createAction(CONTENT_MIGRATION_SET_STATUS);
export const contentMigrationFetchStatus = (viewMode) => (dispatch, getState, { request }) => {
    dispatch(contentMigrationFetchStatusRequest());
    const promise = request(`/_api/content-migration/details?viewMode=${viewMode || getViewMode(getState())}`);
    return promise
        .then((details) => dispatch(contentMigrationFetchStatusSuccess(details)), () => dispatch(contentMigrationFetchStatusFailure()))
        .then(() => promise);
};
export const fetchContentMigrationStatusForBusinessManager = () => (dispatch, getState) => {
    const state = getState();
    return isOwner(state)
        ? dispatch(contentMigrationFetchStatus('editor'))
        : Promise.resolve();
};
export const CONTENT_MIGRATION_ROLLBACK_REQUEST = 'contentMigration/ROLLBACK_REQUEST';
export const CONTENT_MIGRATION_ROLLBACK_SUCCESS = 'contentMigration/ROLLBACK_SUCCESS';
export const CONTENT_MIGRATION_ROLLBACK_FAILURE = 'contentMigration/ROLLBACK_FAILURE';
export const contentMigrationRollbackRequest = createAction(CONTENT_MIGRATION_ROLLBACK_REQUEST);
export const contentMigrationRollbackSuccess = createAction(CONTENT_MIGRATION_ROLLBACK_SUCCESS);
export const contentMigrationRollbackFailure = createAction(CONTENT_MIGRATION_ROLLBACK_FAILURE);
export const contentMigrationRollback = () => (dispatch, getState, { request }) => {
    dispatch(contentMigrationRollbackRequest());
    const viewMode = getViewMode(getState());
    const promise = request.post(`/_api/content-migration/rollback?viewMode=${viewMode}`);
    return promise
        .then((details) => dispatch(contentMigrationRollbackSuccess(details)), () => dispatch(contentMigrationRollbackFailure()))
        .then(() => promise);
};
export const CONTENT_MIGRATION_SET_REDIRECTS_REQUEST = 'contentMigration/SET_REDIRECTS_REQUEST';
export const CONTENT_MIGRATION_SET_REDIRECTS_SUCCESS = 'contentMigration/SET_REDIRECTS_SUCCESS';
export const CONTENT_MIGRATION_SET_REDIRECTS_FAILURE = 'contentMigration/SET_REDIRECTS_FAILURE';
export const contentMigrationSetRedirectsRequest = createAction(CONTENT_MIGRATION_SET_REDIRECTS_REQUEST);
export const contentMigrationSetRedirectsSuccess = createAction(CONTENT_MIGRATION_SET_REDIRECTS_SUCCESS);
export const contentMigrationSetRedirectsFailure = createAction(CONTENT_MIGRATION_SET_REDIRECTS_FAILURE);
export const contentMigrationSetRedirects = () => (dispatch, getState, { request }) => {
    dispatch(contentMigrationSetRedirectsRequest());
    const viewMode = getViewMode(getState());
    const promise = request.post(`/_api/content-migration/set-redirects?viewMode=${viewMode}`);
    return promise
        .then((details) => dispatch(contentMigrationSetRedirectsSuccess(details)), () => dispatch(contentMigrationSetRedirectsFailure(MIGRATION_STATUS_REDIRECTS_SET_FAILED)))
        .then(() => promise);
};
//# sourceMappingURL=content-migration-actions.js.map